// jQuery wrapper
(function ($) {

    /**
     ** Document ready
     **/
    $(document).ready(function () {

        $('body').addClass('active');

        /*
        // InView - Animate when in viewport (useful for content at top of page)
        $(".animate").on("inview", function (event, isInView) {
            var element = $(this);

            if (isInView) {
                element.addClass("ani-trigger");
            }
        });
        */


        // WOW.js for animations 
        new WOW().init();


        // Smooth Scroll
        $('a.smooth-scroll, button.smooth-scroll').on('click', function (event) {
            event.preventDefault();
            var target = $(this).data('target');
            var headerHeight = $('#site-header .header-inner').outerHeight();
            var scrollPosition = $(target).offset().top - (headerHeight + 50);
            // var scrollPosition = $(target).offset().top;

            // console.log(headerHeight);

            $('html').animate({
                scrollTop: scrollPosition
            }, 1000);
        });


        /*****
         * Menus
         *****/
        // Desktop Main Menu
        $('.main-menu-trigger').click(function () {
            var target = $(this).data('target');

            if ($(this).hasClass('is-active')) {
                $(this).removeClass('is-active');
                $('body').removeClass('menu-open');
                $(target).removeClass('open');
            } else {
                $(this).addClass('is-active');
                $('body').addClass('menu-open');
                $(target).addClass('open');
            }
        });

        // Hamburger & Mobile Menu
        $('.hamburger').click(function () {
            var target = $(this).data('target');

            if ($(this).hasClass('is-active')) {
                $(this).removeClass('is-active');
                $(target).removeClass('open');
                $('body').removeClass('mobile-menu-open');
                // $('#main-menu .sub-menu').removeClass('current');
                // $('#main-menu .child-menu').removeClass('current');
            } else {
                $(this).toggleClass('is-active');
                $(target).addClass('open');
                $('body').addClass('mobile-menu-open');
            }
        });

        // Bootstrap drop-downs - close main menu on click
        $('.dropdown-toggle').click(function () {
            $('body').removeClass('menu-open');
            $('.main-menu-trigger').removeClass('is-active');
            $('#main-menu').removeClass('open');
        });


        // News filter
        if ($('#news-filter').length > 0) {
            $('.filter-toggle').click(function () {
                $('.filter-wrap').toggleClass('open');
            });

            // Dropdowns Select2
            $('#cat').select2({
                minimumResultsForSearch: Infinity,
                allowClear: false,
                width: '100%',
                placeholder: 'Categories',
                //dropdownCssClass: 'filter_dropdown',
            });
            $('#archives-dropdown-2').select2({
                minimumResultsForSearch: Infinity,
                allowClear: false,
                width: '100%',
                placeholder: 'Date',
                //dropdownCssClass: 'filter_dropdown',
            });
        }


        // Accordion list (FAQ setc.)
        if ($('.accordion-list').length > 0) {
            $('.accordion-list .answer:not(.active)').hide();
            // var allPanels = $('.accordion-list .answer');

            $('.accordion-list .accordion-toggle').click(function () {
                // var targetParent = $(this).data('parent');
                var target = $(this).data('target');
                var targetCard = $(this).data('card');

                // console.log(targetParent);

                if ($(target).hasClass('active')) {
                    $(this).removeClass('current');
                    $(target).removeClass('active').slideUp(250);
                    $(targetCard).removeClass('bg-white').addClass('bg-gold-tp');

                } else {
                    // Close other open accordions
                    $('.accordion-list .accordion-toggle').removeClass('current');
                    $('.accordion-item .card.bg-white').removeClass('bg-white').addClass('bg-gold-tp');
                    $('.accordion-list .answer').removeClass('active').slideUp(250);

                    $(this).addClass('current');
                    $(target).addClass('active').slideDown(250);
                    $(targetCard).removeClass('bg-gold-tp').addClass('bg-white')
                }

                // Prevent default 'link' behaviour
                return false;
            });
        }


        // Section Nav toggle
        $('.section-nav-toggle').click(function () {
            $(this).toggleClass('active');
            $('.section-nav .nav').toggleClass('open');
        });
        $('.section-nav .nav .btn').click(function () {
            $('.section-nav-toggle').removeClass('active');
            $('.section-nav .nav').removeClass('open');
        });


        // Video modal toggle open/closed
        $('.video-toggle').click(function () {
            var target = $(this).data('target');
            $(target).modal('toggle');
        });
        // Video modal - Empty player on close	    
        $('.close-video').click(function () {
            $('.video-container').empty();
        });


        // Pop-out form 
        $('.popout-form-trigger').click(function () {
            $('#popout-form').toggleClass('open');
        });

        // Hero video autoplay on interaction
        if ($('.hero-iframe').length > 0) {
            heroAutoplay();
        }


        /***
         * Carousels
         ***/
        // Slick Carousels
        // News & Articles
        if ($('.news-carousel').length > 0) {
            $('.news-carousel').slick({
                adaptiveHeight: false,
                slidesToShow: 2,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 5000,
                fade: false,
                arrows: true,
                prevArrow: $('.news-controls .news-prev'),
                nextArrow: $('.news-controls .news-next'),
                infinite: true,
                centerMode: false,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });
        }

        // CTA Blocks - Mobile
        if ($('#cta-blocks .cta-carousel').length > 0) {
            $('.cta-carousel').slick({
                adaptiveHeight: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                fade: false,
                arrows: true,
                prevArrow: $('.cta-carousel-controls .cta-prev'),
                nextArrow: $('.cta-carousel-controls .cta-next'),
                infinite: true,
                centerMode: false,
            });
        }

        // Videos - Homepage
        if ($('.video-carousel').length > 0) {
            $('.video-carousel').slick({
                adaptiveHeight: false,
                slidesToShow: 2,
                slidesToScroll: 1,
                autoplay: false,
                // autoplaySpeed: 5000,
                fade: false,
                arrows: true,
                prevArrow: $('.video-controls .video-prev'),
                nextArrow: $('.video-controls .video-next'),
                infinite: true,
                centerMode: false,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });
        }

        // Treatments - Patient Experience
        if ($('.patient-experience-carousel').length > 0) {
            $('.patient-experience-carousel').slick({
                adaptiveHeight: false,
                slidesToShow: 2,
                slidesToScroll: 1,
                autoplay: false,
                fade: false,
                arrows: true,
                prevArrow: $('.patient-experience-controls .patient-experience-prev'),
                nextArrow: $('.patient-experience-controls .patient-experience-next'),
                infinite: false,
                centerMode: false,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });
        }

        // Testimonials
        if ($('.testimonial-carousel').length > 0) {
            $('.testimonial-carousel').slick({
                adaptiveHeight: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                fade: true,
                arrows: true,
                prevArrow: $('.testimonial-controls .testimonial-prev'),
                nextArrow: $('.testimonial-controls .testimonial-next'),
                infinite: true,
                centerMode: false,
            });
        }

        // Side Effects
        if ($('.side-effects-carousel')) {
            $('.side-effects-carousel').slick({
                adaptiveHeight: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                fade: false,
                arrows: true,
                prevArrow: $('.side-effects-controls .side-effects-prev'),
                nextArrow: $('.side-effects-controls .side-effects-next'),
                infinite: false,
                centerMode: false,
            })
        }

    }); // End Document Ready


    // On load
    $(window).on('load', function () {

        // Header bar scrolled
        scrollbarState();

        // Section nav scroll state
        if ($('.section-nav').length > 0) {
            sectionNavState();
        }

        // Carousel Equal Heights
        carouselEqualHeights();

    });


    // On Scroll
    $(window).on('scroll', function () {

        // Header bar scrolled
        scrollbarState();

        // Section nav scroll state
        if ($('.section-nav').length > 0) {
            sectionNavState();
        }

    });


    // On Resize
    $(window).on('resize', function () {

        // Carousel Equal Heights
        carouselEqualHeights();

    });


    /***
    ** Functions
    ***/

    // Header bar scrolled
    function scrollbarState() {
        // Header bar height
        var navHeight = $('#site-header .header-inner').outerHeight();

        // Position of div which trigger header change
        // var scrollChangePoint = $('.scroll-change-point').offset().top;

        if ($(document).scrollTop() > navHeight) {
            $('body').addClass('scrolled');
            $('#site-header').addClass('is-scrolled');
        } else {
            $('body').removeClass('scrolled');
            $('#site-header').removeClass('is-scrolled');
        }
    }

    // Section Nav scrolled
    function sectionNavState() {
        // Header bar height
        var navHeight = $('#site-header .header-inner').outerHeight();
        // Section nav height
        var sectionNavHeight = $('.section-nav-static').outerHeight();
        var totalHeight = navHeight + sectionNavHeight;


        if ($(document).scrollTop() > totalHeight) {
            // $('#section-nav').addClass('is-sticky');
            $('body').addClass('section-nav-sticky')
        } else {
            // $('#section-nav').removeClass('is-sticky');
            $('body').removeClass('section-nav-sticky')
        }
    }


    // Carousel - Equal heights
    function carouselEqualHeights() {
        $('.carousel.equal').on('setPosition', function () {
            $(this).find('.slick-slide').height('auto');
            var slickTrack = $(this).find('.slick-track');
            var slickTrackHeight = $(slickTrack).height();
            $(this).find('.slick-slide').css('height', slickTrackHeight + 'px');
        });
    }


    // Hero video autoplay on interaction
    function heroAutoplay() {
        var videoLoaded = false;

        function loadVideo() {
            if (!videoLoaded) {
                $('.hero-iframe').each(function () {
                    var baseSrc = $(this).data('src');
                    $(this).attr('src', baseSrc + '&autoplay=1');
                    $(this).addClass('loaded');
                });
                videoLoaded = true;
            }
        }

        // Fire on first interaction
        $(document).one('mousemove click keydown touchstart', loadVideo);
    }


    // end jQuery wrapper
})(jQuery);
